<div class="section-line">
    <div class="section-line__title">{{ text }}</div>
    <ng-content></ng-content>
</div>
